import { render, staticRenderFns } from "./lectoParamsDown.vue?vue&type=template&id=2dd70c1e&scoped=true"
import script from "./lectoParamsDown.vue?vue&type=script&lang=js"
export * from "./lectoParamsDown.vue?vue&type=script&lang=js"
import style0 from "./lectoParamsDown.vue?vue&type=style&index=0&id=2dd70c1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd70c1e",
  null
  
)

export default component.exports